import React, { useState } from 'react';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/style/table.module.scss';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';

export const SearchFilter = ({ ui }) => {
    const [search, setSearch] = useState<string>(ui.state.search ?? '');

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            ui.setters.setSearch(search);
        }
    };

    const handleClear = () => {
        setSearch('');
        ui.setters.setSearch('');
    };

    return (
        <TextInput
            placeholder={'Search Risks by Name'}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onClear={handleClear}
            maxLength={200}
            onKeyDown={onKeyDown}
            className={classes.textInput}
            searchable={true}
            onSearch={() => ui.setters.setSearch(search)}
        />
    );
};
